import { ConfirmDialog } from "@scmlatam/web-ui";
import type { useDeleteConfirm } from "../hooks/useDeleteConfirm";

const DeleteConfirm = (
  deleteConfirmProps: ReturnType<typeof useDeleteConfirm>,
) => {
  return (
    <>
      <ConfirmDialog
        open={deleteConfirmProps.open}
        iconType="warning"
        title={deleteConfirmProps.t("title")}
        message={deleteConfirmProps.t("message")}
        confirmText={deleteConfirmProps.t("buttons.delete")}
        cancelText={deleteConfirmProps.t("buttons.cancel")}
        onClose={() => deleteConfirmProps.setOpen(false)}
        onConfirm={() => deleteConfirmProps.deleteResult()}
      />
    </>
  );
};

export { DeleteConfirm };
